/**
 * Contexte Flipt partagé (backend + back-office) : clés de flags générées,
 * conventions d'entityId et options client communes. Ce package reste sans
 * dépendance runtime — les SDKs Flipt (@flipt-io/flipt-client-js /
 * @flipt-io/flipt-client-react) sont installés par chaque app.
 */
export * from './flags.generated.js'

export const DEFAULT_FLIPT_URL = 'https://flags.lucie-la-cabane-autonome.fr'

/**
 * Token SDK par défaut — lecture des flags uniquement, assumé public (il est
 * de toute façon embarqué dans le bundle du back-office ; l'API de management
 * est protégée par la policy d'authorization, cf. ops/flipt/policy.rego).
 * Surchargeable par env (FLIPT_SDK_TOKEN backend, VITE_FLIPT_SDK_TOKEN BO).
 */
export const DEFAULT_FLIPT_SDK_TOKEN =
  '32fd97c6a726131d63730c5eca3623c5559e01dc59b5947980a8595c91dc42f5'

/**
 * Environnements déclarés dans ops/flipt/flipt.yml. Flipt v2 utilise le `name`
 * comme clé d'API : les names y sont alignés sur les modes Vite du back-office
 * et sur le mapping NODE_ENV du backend — ces valeurs sont donc utilisables
 * telles quelles par les SDKs.
 */
export type FliptEnvironment = 'development' | 'staging' | 'production'

export const FLIPT_NAMESPACE = 'default'
export const FLIPT_UPDATE_INTERVAL_SECONDS = 60

/** Clé localStorage du snapshot Flipt (back-office, mode hors-ligne). */
export const FLIPT_SNAPSHOT_STORAGE_KEY = 'gozoki.flipt.snapshot'

// Conventions d'entityId (cohérence des rollouts par pourcentage entre apps).
export const ANONYMOUS_ENTITY_ID = 'anonymous'
export const BACKEND_ENTITY_ID = 'gozoki-backend'

export interface GozokiFliptClientOptions {
  url: string
  environment: FliptEnvironment
  namespace: string
  updateInterval: number
  authentication: { clientToken: string }
}

export const buildFliptClientOptions = (params: {
  url?: string
  environment: FliptEnvironment
  clientToken: string
}): GozokiFliptClientOptions => ({
  url: params.url ?? DEFAULT_FLIPT_URL,
  environment: params.environment,
  namespace: FLIPT_NAMESPACE,
  updateInterval: FLIPT_UPDATE_INTERVAL_SECONDS,
  authentication: { clientToken: params.clientToken },
})

// oxlint-disable-next-line typescript/consistent-type-definitions
export type FliptEvaluationContext = {
  email: string
}

export const buildFliptContext = (user?: FliptEvaluationContext | null): Record<string, string> =>
  user
    ? {
        email: user.email,
      }
    : {}
